
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/location",
      function () {
        return require("private-next-pages/location.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/location"])
      });
    }
  